import type { UtmParamsInterface } from '~/types/utmTypes'
import UtmEnum from '~/enums/UtmEnum'
import TtlEnum from '~/enums/TtlEnum'
import * as Sentry from '@sentry/vue'
import { fetchRetryParameters, requestHostHeaders, type RequestHostHeadersType } from '~/composables/constants/api'

export const useUtm = () => {
  const init = async () => {
    const route = useRoute()
    let utmObject: UtmParamsInterface = {}
    const utmCookieParams = [UtmEnum.UtmCampaign, UtmEnum.UtmMedium, UtmEnum.UtmSource]

    for (const name in route.query) {
      if (String(name).toUpperCase().startsWith('UTM_')) {
        utmObject[name] = route.query[name] as string
      }
    }

    if (!Object.keys(utmObject).length) {
      utmObject = getCookieValues()
    }

    if (Object.keys(utmObject).length) {
      setCookieValues(utmObject)

      await $fetch('/api/utm', {
        method: 'POST',
        body: utmObject,
        ...fetchRetryParameters,
        timeout: 2000,
        retry: 3,
        headers: useRequestHeaders<RequestHostHeadersType>(requestHostHeaders),
      }).catch((error) => {
        Sentry.captureException(error, (scope) => {
          scope.setContext('Server Response', error.data)

          return scope
        })
      })
    }

    function setCookieValues(utmObject: UtmParamsInterface) {
      for (const prop in utmObject) {
        const utmCookieParam: string = prop
        const utmCookieValue: string | null = utmObject[prop]

        const utmCookie = useCookie(utmCookieParam, {
          maxAge: TtlEnum.NinetyDays,
        })

        utmCookie.value = utmCookieValue
      }
    }

    function getCookieValues(): UtmParamsInterface {
      const utmObject: UtmParamsInterface = {}

      utmCookieParams.forEach((utmCookieParam: UtmEnum) => {
        const utmCookie = useCookie(utmCookieParam, {
          maxAge: TtlEnum.NinetyDays,
        })

        const cookieVal = utmCookie.value ?? null

        if (cookieVal !== null) {
          utmObject[utmCookieParam] = utmCookie.value ?? null
        }
      })

      return utmObject
    }
  }

  return {
    init,
  }
}
